import 'angular';

import '../../app-lite/imports/imports.module.ajs';

import { ImportsStates } from './imports.states.ajs';

angular.module('workshop.imports', [
  'app-lite.imports'
]).config(ImportsStates);
